export class Voucher {
  activatedOn;
  expiresOn;
  batchName;
  batchSize;
  clientId;
  downSpeedTransformedValue;
  downSpeedUnitType;
  downSpeedValue;
  downloadTransformedValue;
  downloadUnitType;
  downloadValue;
  enabled;
  id;
  username;
  timeLimitTransformedValue;
  timeLimitUnitType;
  timeLimitValue;
  trafficLeft;
  usedDevicesMac;
  voucherCode;
  numberOfDevicesAllowed;

  constructor(obj?: Voucher) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/vouchers/voucher.model.ts